import { render, staticRenderFns } from "./port-domestic.vue?vue&type=template&id=4a935b7e&scoped=true&"
import script from "./port-domestic.vue?vue&type=script&lang=js&"
export * from "./port-domestic.vue?vue&type=script&lang=js&"
import style0 from "./port-domestic.vue?vue&type=style&index=0&id=4a935b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a935b7e",
  null
  
)

export default component.exports